(() => {
  const playSafe = (video) => {
    video.muted = true;
    video.playsInline = true;
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  const slides = document.querySelectorAll('.slideshow__slide');

  if (slides.length) {
    const pauseAllInSlide = (slide) => {
      slide.querySelectorAll('video').forEach((v) => v.pause());
    };

    const playFirstInSlide = (slide) => {
      const v = slide.querySelector('video');
      if (v) playSafe(v);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          const slide = target;
          const visibleEnough = isIntersecting && intersectionRatio >= 0.6;

          if (visibleEnough) {
            // Pause videos in other slides (optional but recommended)
            slides.forEach((s) => s !== slide && pauseAllInSlide(s));
            playFirstInSlide(slide);
          } else {
            pauseAllInSlide(slide);
          }
        });
      },
      { threshold: [0, 0.25, 0.6, 1] }
    );

    slides.forEach((s) => io.observe(s));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) document.querySelectorAll('.slideshow__slide video').forEach(v => v.pause());
    });
  }

  /**
   * Keeps a video's play/pause button icon and label in sync with the
   * <video>'s actual playing state, however it was paused/played (button
   * click, scroll-based auto pause/play, tab visibility, etc).
   */
  const updateToggleBtn = (video) => {
    const videoComponent = video.closest('[data-slide-video]');
    const btn = videoComponent && videoComponent.querySelector('[data-play-pause]');
    if (!btn) return;

    btn.classList.toggle('is-paused', video.paused);
    btn.setAttribute('aria-pressed', String(video.paused));
    btn.setAttribute('aria-label', video.paused ? btn.dataset.playLabel : btn.dataset.pauseLabel);
  };

  /**
   * Ties each slide's play/pause button to its video-component's <video>.
   */
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-play-pause]');
    if (!btn) return;

    const videoComponent = btn.closest('[data-slide-video]');
    const video = videoComponent && videoComponent.querySelector('video');
    if (!video) return;

    if (video.paused) {
      playSafe(video);
    } else {
      video.pause();
    }

    // Update immediately rather than waiting on the 'play'/'pause' event
    // (video.paused flips synchronously as soon as play()/pause() is called).
    updateToggleBtn(video);
  });

  // 'play'/'pause' don't bubble, but a capturing listener on document still
  // sees them on their way down to the <video> target. Catches state changes
  // that don't go through the click handler above (auto pause/play on
  // scroll, tab visibility, etc).
  ['play', 'pause'].forEach((type) => {
    document.addEventListener(type, (evt) => {
      if (evt.target.tagName === 'VIDEO') updateToggleBtn(evt.target);
    }, true);
  });
})();
